import { SearchTerm } from './SearchTerm';

const AdvancePermissionSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "trnName",
        translationKey: "name"
    }
];

export default AdvancePermissionSearch;
